import React, { useEffect, useState, useRef } from "react";
import aboutImg from './images/home-about.jpg'
import { ImCheckmark } from "react-icons/im";
import useIntersectionObserver from "./home-animation";
export default function HomeAbout() {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef2, isVisible2] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef3, isVisible3] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef4, isVisible4] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef5, isVisible5] = useIntersectionObserver({ threshold: 0.1 });
    const [counted, setCounted] = useState(false);
    const countRefs = useRef([]);
    useEffect(() => {
        const handleScroll = () => {
            if (!counted && isVisible1 && isVisible2) {
                countRefs.current.forEach((ref, index) => {
                    const countTo = parseInt(ref.getAttribute("data-count"), 10);
                    animateCount(ref, countTo, 2000);
                });
                setCounted(true); // Update the state to prevent animation on subsequent scrolls
            }
        };

        const animateCount = (element, countTo, duration) => {
            const start = parseInt(element.innerText, 10);
            let startTime = null;

            const step = (currentTime) => {
                if (!startTime) {
                    startTime = currentTime;
                }

                const progress = Math.min((currentTime - startTime) / duration, 1);
                const value = Math.floor(progress * (countTo - start) + start);
                element.innerText = value;

                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };

            requestAnimationFrame(step);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [counted, isVisible1, isVisible2,isVisible3,isVisible4,isVisible5]);
    return (
        <div className="home-about">
            <div className="outer-container">
                <div className="home-about-div">
                <div className="home-about-left">
                    <div className="home-about-inner-left">
                        <div className="home-about-overlay"></div>
                        <div className="home-about-div">
                            <div className={`home-about-experience ${isVisible1 ? 'animate__slideInDown' : ''}`}  style={{ animationDuration: '1.25s' }}  ref={sectionRef1}>
                                <div>
                                <span className="home-about-experience-span1" ref={(el) => (countRefs.current[0] = el)} data-count="15">0</span><span className="home-about-experience-span2">+</span>
                                </div>
                                <div className="elementor-counter-title">Years Experience</div>
                            </div>
                                <div className={`about-div-img mask1 ${isVisible2? 'animate__slideInLeft' : ''}`}  style={{ animationDuration: '1.25s' }}  ref={sectionRef2}>
                                    <img src={aboutImg} className="about-img-div" alt="about" width="600" height="auto"/>
                                </div>
                        </div>
                       
                    </div>
                 
                </div>
                <div className="home-about-right">
                <h4 className="home-about-head">About Us</h4>
                <h5 class={`home-about-main-head ${isVisible3 ? 'animate__fadeInUp' : ''}`}  style={{ animationDuration: '1.25s' }}  ref={sectionRef3}>Your Journey to Success Begins Here</h5>
                <p className="main-para"> We are dedicated to bridging the gap between job seekers and employers. Our platform offers innovative solutions for job placement, career development, and talent management, ensuring that both candidates and companies find their perfect match.</p>
                <ul className="home-about-ul">
                    <li className={`home-about-li ${isVisible4? 'animate__fadeInRight' : ''}`}   style={{ animationDuration: '1.25s' }}  ref={sectionRef4}>
                        <div className="home-about-li-left"><ImCheckmark/></div>
                        <div className="home-about-li-right">
                            <h6 className="home-about-check">Thousands of Opportunities</h6>
                            <p className="main-para">
                            Explore a vast array of job listings tailored to various industries and skill sets, connecting you with potential employers worldwide.</p>
                        </div>
                    </li>
                    <li className={`home-about-li ${isVisible5? 'animate__fadeInRight' : ''}`}   style={{ animationDuration: '1.25s' }}  ref={sectionRef5}>
                        <div className="home-about-li-left"><ImCheckmark/></div>
                        <div className="home-about-li-right">
                            <h6 className="home-about-check">Find the Perfect Match</h6>
                            <p className="main-para">
                            Utilize our powerful recruitment tools to effortlessly find and connect with top talent that matches your organization's needs, streamlining the hiring process and ensuring the best candidates for your team.</p>
                        </div>
                    </li>
                </ul>
                </div>
                </div>                
            </div>
        </div>
    );
}
